import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) { /* fallthrough */ }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.msg === "string") return detail.msg;
    if (typeof detail.detail === "string") return detail.detail;
  }
  return String(detail);
}

export const apiError = (e) => formatApiErrorDetail(e.response?.data?.detail) || e.message;

export const mediaUrl = (adId, variant = "thumb") =>
  `${process.env.REACT_APP_BACKEND_URL}/api/media/${adId}/${variant}`;

export const downloadUrl = (adId, variant = "original") =>
  `${process.env.REACT_APP_BACKEND_URL}/api/ads/${adId}/download?variant=${variant}`;

export const avatarUrl = (userId, cacheBuster = "") =>
  `${process.env.REACT_APP_BACKEND_URL}/api/avatars/${userId}${cacheBuster ? `?v=${cacheBuster}` : ""}`;

export default api;
